import * as Sentry from '@sentry/react'
import { env, sentry } from './configuration'

if (sentry.enabled) {
  const tracePropagationTargets = [
    'localhost',
    /^https:\/\/.*\.api\.audio/,
    /^https:\/\/(?!login\.|authenticate\.).*\.audiostack\.ai/,
  ]
  Sentry.init({
    dsn: sentry.dsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets,
    tracesSampleRate: 1.0,
    environment: env,
    sendDefaultPii: true,
  })
}

declare global {
  interface Window {
    StartDebugToolbar: (mode: 'prod' | 'stg') => void
  }
  interface SentryToolbar {
    init: (props: {
      enabled: boolean
      organizationSlug: string
      projectIdOrSlug: string
    }) => void
  }
  const SentryToolbar: SentryToolbar
  const StartDebugToolbar: (mode: 'prod' | 'stg') => void
}

if (env === 'development') {
  window.StartDebugToolbar = (mode) => {
    const s = document.createElement('script')
    s.src =
      'https://browser.sentry-cdn.com/sentry-toolbar/latest/toolbar.min.js'
    s.onload = () => {
      const projectSlug = mode === 'prod' ? 'feather-prod' : 'feather-staging'
      SentryToolbar.init({
        enabled: true,
        organizationSlug: 'aflorithmic-lab',
        projectIdOrSlug: projectSlug,
      })
    }
    document.head.appendChild(s)
  }
}
